import { Dimensions } from "@faire/slate/foundation/dimensions";

export const SKELETON_VARIANTS = [
  "canvas",
  "square",
  "circle",
  "titleText",
  "paragraphText",
  "round",
] as const;

export const DEFAULT_SKELETON_IMAGE_SIZE = 240;
export const DEFAULT_SKELETON_AVATAR_DIAMETER = 64;
export const DEFAULT_SKELETON_TITLE_TEXT_WIDTH = 136;
export const DEFAULT_SKELETON_TITLE_TEXT_HEIGHT_REM = Dimensions.rem[8];
export const DEFAULT_SKELETON_PARAGRAPH_TEXT_WIDTH = 240;
export const DEFAULT_SKELETON_PARAGRAPH_TEXT_HEIGHT_REM = Dimensions.rem[5];
export const DEFAULT_SKELETON_ROUND_WIDTH = 136;
export const DEFAULT_SKELETON_ROUND_HEIGHT = 40;
